<template>
  <div class="PageContent">
    <div v-show="isLoading">
      <PreLoad />
    </div>
    <div v-if="page">
        <div class="content" v-html="page.html"></div>
    </div>
  </div>
</template>

<script>
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'PageContent',
  components: {
    PreLoad
  },
  data () {
    return {
      page: null,
      isLoading: true
    }
  },
  props: {
    mode: String
  },
  mounted () {
    const query = `
    {
      content(key:"${this.mode}"){
        id
        html
      }
    }
    `
    this.$fetchGraphQL(query)
      .then(res => {
        this.page = res.data.content
        this.isLoading = false
      })
  }
}
</script>

<style scoped>
</style>
